(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gift-card-recipient-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initRecipientForm = (root) => {
      const sectionId = root.dataset.sectionId;
      const checkbox = root.querySelector(`#Recipient-checkbox-${sectionId}`);
      const fieldsPanel = root.querySelector('[data-recipient-fields]');
      const liveRegion = root.querySelector(`#Recipient-fields-live-region-${sectionId}`);
      const offsetField = root.querySelector(`#Recipient-timezone-offset-${sectionId}`);
      const controlField = root.querySelector(`#Recipient-control-${sectionId}`);
      const emailRequiredLabel = root.querySelector('[data-recipient-email-required]');
      const emailOptionalLabel = root.querySelector('[data-recipient-email-optional]');

      if (!checkbox || !fieldsPanel) return;

      const inputFields = () =>
        root.querySelectorAll(
          '#Recipient-email-' +
            sectionId +
            ', #Recipient-name-' +
            sectionId +
            ', #Recipient-message-' +
            sectionId +
            ', #Recipient-send-on-' +
            sectionId
        );

      const setFieldsEnabled = (enabled) => {
        inputFields().forEach((field) => {
          field.disabled = !enabled;
        });

        if (offsetField) {
          offsetField.disabled = !enabled;
          if (enabled) {
            offsetField.value = new Date().getTimezoneOffset().toString();
          } else {
            offsetField.value = '';
          }
        }

        if (controlField) {
          controlField.disabled = true;
        }
      };

      const clearFields = () => {
        inputFields().forEach((field) => {
          field.value = '';
        });
      };

      const updateState = () => {
        const isChecked = checkbox.checked;

        fieldsPanel.hidden = !isChecked;
        setFieldsEnabled(isChecked);

        if (emailRequiredLabel && emailOptionalLabel) {
          emailRequiredLabel.hidden = !isChecked;
          emailOptionalLabel.hidden = isChecked;
        }

        if (liveRegion) {
          liveRegion.textContent = isChecked
            ? root.dataset.expandedLabel || 'Gift card recipient form expanded'
            : root.dataset.collapsedLabel || 'Gift card recipient form collapsed';
        }

        if (!isChecked) {
          clearFields();
        }
      };

      checkbox.addEventListener('change', updateState);
      updateState();
    };

    const run = () => {
      document.querySelectorAll('[data-gift-card-recipient-form]').forEach(initRecipientForm);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-gift-card-recipient-form]').forEach(initRecipientForm);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
